import { memo } from "react";
import { useTranslation } from "react-i18next";
import Typography from "components/Typography";
import Button from "components/Button";
import type { ButtonProps } from "components/Button";
import PlusIcon from "components/Icons/PlusIcon";
import { OneRepMaxEntriesTableHeaderRoot, OneRepMaxEntriesTableHeading, OneRepMaxEntriesTableToolbar } from ".";

interface OneRepMaxEntriesTableHeaderProps {
  slotProps?: {
    addButton?: ButtonProps & { ref?: React.Ref<HTMLButtonElement> };
  };
}

function OneRepMaxEntriesTableHeader(props: OneRepMaxEntriesTableHeaderProps) {
  const { slotProps } = props;
  const { t } = useTranslation();

  return (
    <OneRepMaxEntriesTableHeaderRoot>
      <OneRepMaxEntriesTableHeading>
        <Typography sx={{ fontWeight: "fontWeightMedium" }}>{t("charting.one_rep_max_table_title")}</Typography>
        <Typography variant="TextXS" sx={{ color: "grey.120" }}>
          {t("charting.one_rep_max_table_description")}
        </Typography>
      </OneRepMaxEntriesTableHeading>
      <OneRepMaxEntriesTableToolbar>
        <Button size="small" variant="tertiary" startIcon={<PlusIcon />} {...slotProps?.addButton}>
          {t("charting.one_rep_max_table_add_button")}
        </Button>
      </OneRepMaxEntriesTableToolbar>
    </OneRepMaxEntriesTableHeaderRoot>
  );
}

export default memo(OneRepMaxEntriesTableHeader);
